import { createFileRoute } from '@tanstack/react-router'
import { ProjectDetailsPage } from '@/features/projects/pages/project-details-page'
import { fetchProjectById } from '@/features/projects/queries/project-queries'

export const Route = createFileRoute('/_authenticated/_sidebar/grower/projects/$projectId/')({
	component: ProjectDetails,
	loader: async ({ params }) => {
		const { projectId } = params
		try {
			const response = await fetchProjectById(projectId)
			return response.data
		} catch (error) {
			throw error
		}
	},
})

function ProjectDetails() {
	const project = Route.useLoaderData()
	return <ProjectDetailsPage project={project} />
}

